<template>
	<div
		id="itemPreviewContent"
		class="preview"
		:class="{
			video: !onMedia() && selectedMediaType === MEDIA_ID.VIDEO,
			email: !onMedia() && selectedMediaType === MEDIA_ID.EMAIL,
		}"
	>
		<!-- PLACEHOLDER -->
		<PreviewPlaceholder v-if="onMedia()" />

		<!-- FLYER -->
		<div
			class="flyer-outer-container"
			v-if="!onMedia() && selectedMediaType === MEDIA_ID.FLYER"
		>
			<VRuntimeTemplate
				v-if="!onMedia() && selectedMediaType === 1"
				:template="getCurrentTemplate()"
			></VRuntimeTemplate>
		</div>

		<!-- SOCIAL POST -->
		<div
			id="social-outer-container"
			class="social-outer-container"
			v-if="!onMedia() && selectedMediaType === MEDIA_ID.SOCIAL_MEDIA"
		>
			<VRuntimeTemplate
				v-if="!onMedia() && selectedMediaType === 2"
				:template="getCurrentTemplate()"
			></VRuntimeTemplate>
		</div>

		<!-- EMAIL -->
		<div
			id="emailPreviewTemplate"
			v-if="!onMedia() && selectedMediaType === MEDIA_ID.EMAIL"
		>
			<VRuntimeTemplate :template="getCurrentTemplate()"></VRuntimeTemplate>
		</div>

		<!-- VIDEO -->
		<video
			id="completeVideo"
			ref="completeVideo"
			class="video-container"
			:class="videoIsVertical ? 'vertical-video' : 'horizontal-video'"
			v-if="(selectedMediaType === MEDIA_ID.VIDEO && onVideos()) ||
				(selectedMediaType === MEDIA_ID.VIDEO && onExport())"
			controls
			preload="metadata"
			:autoplay="!onExport() ? true : false"
			:poster="selectedVideo.previewUri"
		>
			<source id="mp4" :src="selectedVideo.uri" type="video/mp4" />
			Sorry, your browser doesn't support embedded videos.
		</video>
		<VRuntimeTemplate
			v-if="
				!onMedia() &&
				!onVideos() &&
				!onExport() &&
				selectedMediaType === MEDIA_ID.VIDEO
			"
			:template="getVideoTemplate()"
		></VRuntimeTemplate>

		<!-- PPT -->
		<img
			alt="Powerpoint Thumbnail"
			v-if="!onMedia() && selectedMediaType === MEDIA_ID.POWERPOINT"
			:src="selectedDesignPreviewUri"
		/>

		<!-- PRICING FLYER -->
		<div
			id="pricingPreviewTemplate"
			class="flyer-outer-container"
			v-if="selectedMediaType === MEDIA_ID.PRICING_FLYER"
			:key="tick"
		>
			<VRuntimeTemplate
				v-if="!onMedia() && selectedMediaType === 6"
				:template="getCurrentTemplate()"
			></VRuntimeTemplate>
		</div>

		<!-- LOADER -->
		<div
			v-if="showLoader"
			id="loading-zone"
			style="
				background-color: #fff;
				position: fixed;
				top: 81px;
				right: 0;
				width: calc(100% - 560px);
				z-index: 100;
				display: flex;
				justify-content: center;
				align-items: center;
			"
		>
			<loading-icon></loading-icon>
			<p
				class="loading-message"
				v-if="!onMedia() && campaignItemMediasLoading && selectedMediaTypeName[0]"
			>
				We are creating your
				{{ selectedMediaTypeName[0].typeName.toLowerCase() }} preview. This
				should just take a moment.
			</p>
			<p
				class="loading-message"
				v-else-if="selectedMediaType === MEDIA_ID.PRICING_FLYER"
			>
				We are creating your custom pricing scenario flyer. This may take a
				minute.
			</p>
			<p
				class="loading-message"
				v-else-if="selectedMediaTypeName.length && selectedMediaType === MEDIA_ID.VIDEO"
			>
				We are creating your custom
				{{ selectedMediaTypeName[0].typeName.toLowerCase() }}. This may take a
				few minutes.
			</p>
			<p
				class="loading-message"
				v-else-if="selectedMediaTypeName.length && selectedMediaType !== MEDIA_ID.EMAIL"
			>
				We are creating your custom
				{{ selectedMediaTypeName[0].typeName.toLowerCase() }}. This may take a
				minute.
			</p>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import PreviewPlaceholder from '@/components/brand-builder/PreviewPlaceholder.vue';
import LoadingIcon from '@/components/global/LoadingIcon.vue';
import VRuntimeTemplate from 'v-runtime-template';
import { videoTemplate } from './ItemPreview-constants';
import { MEDIA_ID } from '@/constants/brand-builder';

export default {
	name: 'ItemPreview',
	comments: true,
	data() {
		return {
			tick: 0,
			comments: `<!--[if mso]>
									<style type="text/css">
									.fallback-font {font-family: Arial, sans-serif;}
									.fallback-banner-font {font-family: Arial, sans-serif;color:#333333 !important;}
									</style>
									<![endif]-->`,
			emailBackgroundImg:
				'https://res.cloudinary.com/uwm/image/upload/w_660,h_300,c_fill_pad,g_auto,b_gen_fill/',
			// TODO : Split the profilePhoto to eventually use the emailProfileImage sizing
			emailProfileImage: 'w_200,h_200/',
			currentLocation: this.$route.fullPath.toString,
			disclaimerText: '',
			disclaimerNoTaxText: '',
			disclaimerTaxText: '',
			MEDIA_ID,
			videoTemplate,
		};
	},
	components: {
		VRuntimeTemplate,
		PreviewPlaceholder,
		LoadingIcon,
	},
	computed: {
		...mapState({
			// eslint-disable-next-line no-confusing-arrow, no-nested-ternary
			videoIsVertical: (state) => state.brandBuilderEditor.videoIsVertical,
			selectedDesign: (state) =>
				//	TODO: remove nested ternary
				// eslint-disable-next-line no-nested-ternary
				!state.brandBuilderEditor.selectedDesign
					? ''
					: !state.brandBuilderEditor.selectedDesign.item
					? ''
					: state.brandBuilderEditor.selectedDesign.item,
			// eslint-disable-next-line no-confusing-arrow
			previewUri: (state) =>
				state.brandBuilderEditor.selectedDesign === null
					? ''
					: state.brandBuilderEditor.selectedDesign.item.medias[
							state.brandBuilderEditor.selectedDesignIndex
					  ].previewUri,
			selectedDesignMediaUri: (state) =>
				state.brandBuilderEditor.selectedDesign.item.medias[
					state.brandBuilderEditor.selectedDesignIndex
				].uri,
			selectedDesignIndex: (state) =>
				state.brandBuilderEditor.selectedDesignIndex,
			personalCompanyLogo: (state) => {
				if (
					state.profile.personalCompanyLogo !== null &&
					state.profile.personalCompanyLogo.imageUri !== null
				) {
					return state.profile.personalCompanyLogo.imageUri;
				}

				return '';
			},
			profilePhoto: (state) => {
				if (
					state.profile.profilePhoto !== null &&
					state.profile.profilePhoto.imageUri !== null
				) {
					return state.profile.profilePhoto.imageUri;
				}

				return '';
			},
			blinkQRCode: (state) => {
				if (
					state.profile.blinkQRCode &&
					state.profile.blinkQRCode.imageUri !== ''
				) {
					return state.profile.blinkQRCode.imageUri;
				}
				return '';
			},
			fullName: (state) => {
				if (state.profile.preferredName) {
					// eslint-disable-next-line prefer-template
					return `${state.profile.preferredName} ${state.profile.lastName}`;
				}
				// eslint-disable-next-line prefer-template
				return state.profile.firstName + ' ' + state.profile.lastName;
			},
			hasCaliforniaLicenses: (state) =>
				state.licenses.list.some((el) => el.state.startsWith('CA')),
			contactLicenses: (state) => state.profile.contactLicenses,
			formattedPhoneNumber: (state) => {
				// eslint-disable-next-line quotes
				let phoneNumberStripped =
					(state.profile.phoneNumber &&
						state.profile.phoneNumber.replace(/[^0-9]/g, '')) ||
					'';

				if (['0', '1'].includes(phoneNumberStripped[0])) {
					phoneNumberStripped = phoneNumberStripped.slice(1);
				}

				const phoneNumberExt = phoneNumberStripped.slice(10);
				const phoneNumberCleaned = phoneNumberStripped.slice(0, 10);
				// eslint-disable-next-line quotes
				const phoneNumberFormatted = phoneNumberCleaned.replace(
					/(\d{3})(\d{3})(\d{4})/,
					'$1-$2-$3',
				);

				if (phoneNumberExt) {
					return `${phoneNumberFormatted} x${phoneNumberExt}`;
				}

				return `(w) ${phoneNumberFormatted}`;
			},
			extension: (state) => {
				if (state.profile.phoneExtension) {
					return ` ext. ${state.profile.phoneExtension}`;
				}
				return undefined;
			},
			cellPhoneNumber: (state) => {
				if (state.profile.mobilePhoneNumber) {
					return `(c) ${state.profile.mobilePhoneNumber}`;
				}
				return undefined;
			},
			selectedFlyer: (state) => state.brandBuilderEditor.selectedTemplate.html,
			brandingOptions: (state) => {
				if (!state.profile.blinkRegistrationInd) {
					state.workspaceBranding.brandingOptions[11].selected = false;
					state.workspaceBranding.brandingOptions[11].disabled = true;
				}

				return state.workspaceBranding.brandingOptions;
			},
			showLoader: (state) => state.brandBuilderEditor.showLoader,
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
			profile: (state) => state.profile,
			companyProfile: (state) => state.companyProfile,
			// TODO: Needed?
			sampleResponse: (state) => state.brandBuilderEditor.campaignItems,
			selectedImage: (state) => state.brandBuilderEditor.selectedImage,
			// eslint-disable-next-line no-confusing-arrow
			licenseList: (state) =>
				state.licenses.licenseList !== undefined
					? state.licenses.licenseList.filter(
							(license) => license.selected === true,
					  )
					: '',
			controls: (state) => state.brandBuilderEditor.controlValues,
			// eslint-disable-next-line no-confusing-arrow
			complianceLogo: (state) =>
				state.complianceLogos.selectedLogos &&
				state.complianceLogos.selectedLogos.length > 0
					? state.complianceLogos.selectedLogos[0].uri
					: '',
			selectedMediaTypeName: (state) =>
				state.brandBuilderEditor.mediaTypeArray.filter(
					(x) => x.selected === true,
				),
			pricingImages: (state) => state.lendwizePricingScenario.flyerImages,
			pricingData: (state) => state.lendwizePricingScenario.flyerData,
			isRefi: (state) =>
				state.lendwizePricingScenario.selectedLoanPurpose === 'REFINANCE',
			pricingDataLtv: (state) => state.lendwizePricingScenario.ltv,
			selectedItemVariationsLength: (state) => {
				if (
					state.brandBuilderEditor.selectedItem &&
					state.brandBuilderEditor.selectedItem.variations
				) {
					return state.brandBuilderEditor.selectedItem.variations.length;
				}
				return null;
			},
			selectedTextVariationIndex: (state) =>
				state.brandBuilderEditor.selectedTextVariationIndex,
			fhaDisclaimerText: (state) => state.lendwizePricingScenario.fhaDisclaimer,
			hasDreLicense: (state) =>
				Object.entries(state.profile.contactLicenses).length > 0,
			dreLicenses: (state) => {
				const { contactLicenses } = state.profile;
				let res = '';
				// TODO: refactor to Object.values
				// eslint-disable-next-line no-unused-vars
				Object.entries(contactLicenses).forEach(([key, val]) => {
					if (val !== '') {
						if (res === '') res += val;
						else res += `, ${val}`;
					}
				});
				return res;
			},
			campaignItemMediasLoading: (state) =>
				state.brandBuilderEditor.campaignItemMediasLoading,
		}),
		selectedDesignPreviewUri() {
			return !this.selectedDesign ? '' : this.selectedDesign.previewUri;
		},
		flyerDisclaimer: {
			get() {
				return this.$store.state.lendwizePricingScenario.flyerDisclaimer;
			},
			set(value) {
				this.$store.commit('SET_DISCLAIMER', value);
			},
		},
		...mapGetters(['selectedVideo']),
	},
	mounted() {
		if (this.$refs.completeVideo) {
			this.$refs.completeVideo.onloadedmetadata = () => {
				let isVertical =
					this.$refs.completeVideo.videoWidth <
					this.$refs.completeVideo.videoHeight;
				this.setVideoIsVertical(isVertical);
			};
		}
	},
	watch: {
		campaignItemMediasLoading(isLoading) {
			if (!isLoading) {
				this.toggleLoader(false);
			}
		},
		selectedDesignIndex(currentIndex) {
			if (currentIndex !== null && this.$refs.completeVideo) {
				this.$refs.completeVideo.load();
			}
			if (this.$refs.completeVideo) {
				this.$refs.completeVideo.onloadedmetadata = () => {
					let isVertical =
						this.$refs.completeVideo.videoWidth <
						this.$refs.completeVideo.videoHeight;
					this.setVideoIsVertical(isVertical);
				};
			}
		},
		$route() {
			if (this.$refs.completeVideo) {
				this.$refs.completeVideo.pause();
			}
			if (this.campaignItemMediasLoading) {
				if (this.onMedia()) {
					this.toggleLoader(false);
				} else {
					this.toggleLoader(true);
				}
			}
		},
	},
	methods: {
		...mapActions([
			'toggleBrandBuilder',
			'toggleLoader',
			'toggleDashboard',
			'setDefaultItems',
			'setVideoIsVertical',
		]),
		splitJoin(theText) {
			return theText
				.split('â€¢')
				.map((x) => x.trim())
				.filter((x) => x.length > 0);
		},
		getVideoTemplate() {
			this.disclaimerText = this.getDisclaimerText();
			return this.videoTemplate;
		},
		blinkLinkClick(url) {
			let newUrl = url;
			if (newUrl === undefined) newUrl = this.profile.blinkLink;
			window.open(newUrl, '_blank');
		},
		getCurrentTemplate() {
			this.disclaimerText = this.getDisclaimerText();
			if (this.selectedMediaType === MEDIA_ID.PRICING_FLYER) {
				// For Pricing Flyers, select first template
				return !this.$store.state.brandBuilderEditor.campaignItems[0]
					? ''
					: this.$store.state.brandBuilderEditor.campaignItems[0].templates[0]
							.html;
			}
			return !this.$store.state.brandBuilderEditor.selectedTemplate
				? ''
				: this.$store.state.brandBuilderEditor.selectedTemplate.html;
		},
		getPptCurrentTemplate() {
			return this.$store.state.brandBuilderEditor.selectedTemplate.previewUri;
		},
		onMedia() {
			return this.$route.fullPath.match(/media/g);
		},
		onVideos() {
			return this.$route.fullPath.match(/design/g);
		},
		onBranding() {
			return this.$route.fullPath.match(/branding/g);
		},
		onLegal() {
			return this.$route.fullPath.match(/legal/g);
		},
		onPreview() {
			return this.$route.fullPath.match(/preview/g);
		},
		onExport() {
			return this.$route.fullPath.match(/export/g);
		},
		getDisclaimerText() {
			const d = new Date();
			const dateText = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
			let text = '';
			const disclaimerTextList = [];

			// Licenses should be disabled for Social Posts.
			if (this.selectedMediaType !== MEDIA_ID.SOCIAL_MEDIA) {
				const selectedItems = this.$store.state.licenses.list.filter(
					(license) => license.isSelected === true,
				);
				selectedItems.forEach((element) => {
					if (!disclaimerTextList.includes(element.disclaimerText)) {
						disclaimerTextList.push(element.disclaimerText);
					}
				});

				// eslint-disable-next-line prefer-template
				text = disclaimerTextList.join(', ') + '.';
			}

			if (
				this.$store.state.brandBuilderEditor.campaignDisclaimers.length ===
				this.selectedItemVariationsLength
			) {
				// for campaigns with copy variation specific disclaimers
				text +=
					this.$store.state.brandBuilderEditor.campaignDisclaimers[
						this.selectedTextVariationIndex
					];
			} else if (
				this.$store.state.brandBuilderEditor.campaignDisclaimers.length >
					this.selectedItemVariationsLength &&
				this.selectedMediaType === MEDIA_ID.SOCIAL_MEDIA
			) {
				// for social flyer on campaigns with multiple dislaimers
				text += this.$store.state.brandBuilderEditor.campaignDisclaimers[0];
			} else {
				this.$store.state.brandBuilderEditor.campaignDisclaimers.forEach(
					(el) => {
						if (typeof el !== 'undefined') {
							const newEl = el.replace('{disclaimerDate}', dateText);

							if (el.indexOf('{disclaimerDate}') === -1) {
								text += newEl;
							} else {
								// TODO: refactor to eliminate esling error
								// eslint-disable-next-line no-lonely-if
								if (el.indexOf('principal') !== -1) {
									this.disclaimerNoTaxText = newEl;
								} else {
									this.disclaimerTaxText = newEl;
								}
							}
						}
					},
				);
			}
			return text;
		},
	},
};
</script>

<style lang="scss">
.preview {
	display: flex;
	justify-content: center;
	margin-left: calc(#{$brand-builder-sub-view-with} + (#{$base-gap} * 2));
	flex-direction: column;
	align-items: center;
	overflow: hidden;
	overflow-y: auto;
	position: relative;
	height: 100%;
	opacity: 1;
	transition: opacity 0.3s ease;
	@include sm {
		height: calc(100% - #{$brand-builder-tool-height});
	}

	@media screen and (max-height: 630px) {
		overflow-y: scroll;
	}

	@include sm {
		margin-left: 0;
	}

	@media only screen and (max-width: $mobile-max) {
		margin-left: 0;
	}

	@include mobile {
		display: block;
		@include rem(margin-left, 15px);
		@include rem(margin-right, 15px);

		/* HTML emailers styles */
		> table {
			margin-bottom: 120px; /* allows the content to show above the Brand Builder Nav. */
		}

		.footer-wrapper p {
			word-break: break-word;
		}
	}

	&.email {
		display: block;
	}

	.flyer-outer-container {
		position: relative;
		/* Fix for mobile */
		max-width: 510px;
		min-width: 320px;
		width: 100%;
		min-height: 320px;
		height: 100%;
		max-height: 660px;

		#item-container.flyer-container {
			position: absolute;
			left: 0;
			top: 0;
			transform-origin: left top;
			background: transparent;
			transition: transform 0.5s ease-in-out;
			margin-bottom: 90px !important;

			@include mobile {
				transform: scale(0.14);
				margin-bottom: 590px;
			}

			@include mobile-min {
				transform: scale(0.115);
			}

			@media only screen and (min-width: 411px) and (max-width: 767px) {
				transform: scale(0.148);
			}

			@media only screen and (min-width: 768px) and (max-width: 1023px) {
				transform: scale(0.2);
			}

			@media only screen and (min-width: 1024px) and (max-width: 1199px) {
				transform: scale(0.175);
			}

			@media only screen and (min-width: 1200px) {
				transform: scale(0.24);
			}

			&.fullscale {
				transform: scale(1) !important;
			}
		}
	}

	.social-outer-container {
		height: 600px;
		width: 600px;
		position: relative;
		@include mobile {
			width: 100%;
			height: 100%;
		}

		@media only screen and (min-width: 1024px) and (max-width: 1199px) {
			width: 80%;
		}

		#item-container.social-post {
			position: absolute;
			left: 0;
			top: 0;
			transform-origin: left top;
			width: 600px !important;
			height: 600px !important;
			transition: all 0.5s ease-in-out;
			transform-origin: top left;

			@include mobile {
				transform: scale(0.575);
				justify-content: unset !important; /* This overwrites the inline style of #item-container */
			}

			@include mobile-min {
				transform: scale(0.48);
			}

			@media only screen and (min-width: 411px) {
				transform: scale(0.635);
			}

			@media only screen and (min-width: ($phablet + 1px)) and (max-width: $breakpoint) {
				transform: scale(1);
			}

			@media only screen and (min-width: 1200px) {
				transform: scale(1);
				transform-origin: top center;
			}

			&.fullscale {
				transform: scale(1);
			}

			#social-image {
				img {
					display: flex;
					object-fit: cover;
				}
				.social-banner {
					h1 {
						p {
							font-size: unset;
							color: unset;
							font-family: unset;
							font-weight: unset;
							margin: unset;
							padding: unset;
						}
					}
					ul {
						li {
							font-size: unset;
							color: unset;
							font-family: unset;
							line-height: unset;
						}
					}
					ol {
						li {
							font-size: unset;
							color: unset;
							font-family: unset;
							line-height: unset;
						}
					}
				}
			}

			&.no-disclaimer {
				height: 530px !important;

				.social-disclaimer {
					display: none;
				}
			}

			h1 {
				font-size: 24px !important;
			}
		}
	}
	#completeVideo {
		transition: all 0.5s ease-in-out;
	}
	.vertical-video {
		height: 85%;
		max-height: 1000px;
		min-height: 300px;
		width: auto;
		@media screen and (max-width: 1080px) {
			width: 70%;
			height: auto;
		}
	}
	.horizontal-video {
		width: 90%;
		max-width: 900px;
		min-width: 320px;
	}

	#item-container {
		// Flyer headline text
		.flyer-image-headline {
			h1 {
				p {
					font-size: 105px;
					color: unset;
					font-family: var(--base-font);
					font-weight: 700;
					margin: unset;
					padding: unset;
				}
				ul {
					li {
						list-style-type: disc;
						font-size: 105px;
						color: unset;
						line-height: 1.7;
					}
				}
				ol {
					li {
						color: unset;
						font-size: 105px;
						line-height: 1.7;
					}
				}
			}
		}

		// Flyer Subheading text
		.flyer-text {
			h2 {
				p {
					text-transform: uppercase;
					line-height: 1;
					font-size: 64px;
					font-weight: 700;
					color: var(--secondary-color);
					font-family: var(--base-font);
					margin-top: 40px;
				}
				ul {
					li {
						list-style-type: disc;
						font-size: 64px;
						color: unset;
					}
				}
				ol {
					li {
						color: unset;
						font-size: 64px;
					}
				}
			}
		}

		// Flyer Body Copy text
		.flyer-text {
			p {
				font-size: 45px;
				color: unset;
				font-family: var(--base-font);
				font-weight: 400;
				margin: unset;
				line-height: unset;
				padding: unset;
			}
			ol {
				li {
					color: unset;
					font-size: 45px;
					line-height: 1.7;
				}
			}
			ul {
				li {
					list-style-type: disc;
					font-size: 45px;
					color: unset;
				}
			}
		}

		// Flyer ending tag line
		.flyer-tagline {
			h2 {
				p {
					text-transform: uppercase;
					font-size: 55px;
					font-weight: 600;
					color: unset;
					font-family: var(--base-font);
					line-height: 1.3;
				}
				ol {
					li {
						color: unset;
						font-size: 55px;
					}
				}
				ul {
					li {
						list-style-type: disc;
						font-size: 55px;
						color: unset;
					}
				}
			}
		}

		// Pricing flyer header
		.pricing-flyer-header-container {
			p {
				font-size: unset;
				color: unset;
				font-family: unset;
				font-weight: unset;
				margin: unset;
				line-height: unset;
				padding: unset;
			}

			ul {
				li {
					font-size: unset;
					color: unset;
					font-family: var(--base-font);
					line-height: unset;
				}
			}

			ol {
				li {
					font-size: unset;
					color: unset;
					font-family: var(--base-font);
					line-height: unset;
				}
			}
		}

		// Pricing flyer subheader
		.pricing-flyer-subheader {
			p {
				font-size: unset;
				color: unset;
				font-family: unset;
				font-weight: unset;
				margin: unset;
				line-height: unset;
				padding: unset;
			}

			ul {
				li {
					font-size: unset;
					color: unset;
					font-weight: 700;
					line-height: unset;
				}
			}

			ol {
				li {
					font-size: unset;
					color: unset;
					font-weight: 700;
					line-height: unset;
				}
			}
		}

		// Pricing flyer table content
		.pricing-flyer-table {
			p {
				font-size: unset;
				color: unset;
				font-family: unset;
				font-weight: unset;
				margin: unset;
				line-height: unset;
				padding: unset;
			}
		}
		&.title-card {
			margin-top: 15px !important;
			transform-origin: top center;
			position: absolute;
			top: 25%;

			@media only screen {
				transform: scale(0.31);
			}

			@include mobile {
				transform: scale(0.17);
			}

			@include mobile-min {
				transform: scale(0.16);
			}

			@media only screen and (min-width: 420px) and (max-width: 600px) {
				transform: scale(0.2);
			}

			@media only screen and (min-width: 1024px) and (max-width: 1199px) {
				transform: scale(0.24);
			}
			&.fullscale {
				transform: scale(1);
				position: unset;
				top: unset;
			}
		}
	}

	.flyer-container,
	.video-container,
	.social-container {
		box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 6px;
	}

	.flyer-container {
		&.no-disclaimer {
			.flyer-disclaimer {
				display: none;
			}
		}
	}

	.banner-wrapper {
		/* This fixes the FormRichText editor paragraph tag overwrites in email banner */
		h1 {
			p {
				font-size: unset;
				color: unset;
				font-family: unset;
				font-weight: unset;
				margin: unset;
				line-height: unset;
				padding: unset;
			}
			ul {
				li {
					font-size: unset;
					color: unset;
					font-family: var(--base-font);
					font-weight: 700;
					line-height: unset;
				}
			}
			ol {
				li {
					font-size: unset;
					color: unset;
					font-family: var(--base-font);
					font-weight: 700;
					line-height: unset;
				}
			}
		}
	}

	.body-wrapper {
		li {
			p {
				padding-bottom: 0;
				margin-top: 0;
			}
		}
	}

	.email-body-text {
		p {
			font-family: var(--base-font) !important;
			line-height: 1.5;
		}
	}

	.flyer-text {
		ul {
			li {
				font-family: var(--base-font) !important;
				font-size: 45px;
			}
		}
	}

	.no-styles {
		margin: 0;
	}

	.scenarios-table {
		width: 100%;
		border: 2px solid #e3e3e3;
		border-collapse: collapse;

		th,
		td {
			padding: 0.7% 2.5%;
			text-align: left;
			border-left: 2px solid #e3e3e3;
			border-bottom: 2px solid $white;

			&:first-of-type {
				max-width: 50%;
				border-left: none;
			}

			p.max-width-2 {
				@include rem(max-width, 560px);
			}

			p.max-width-3 {
				@include rem(max-width, 430px);
			}
		}

		tr {
			th {
				background-color: #ededed;
			}

			&:nth-child(even) {
				td {
					background-color: #ededed;
				}
			}

			&:nth-child(odd) {
				td {
					background-color: #f9f9f9;
				}
			}
		}
	}
}

.flyer-image-container {
	overflow: hidden;
	min-height: 1000px;
	img {
		object-fit: cover;
	}
}

.flyer-footer-content {
	padding-bottom: 25px !important;
}

#loading-zone {
	height: calc(
		100vh - #{$top-nav-height + $brand-builder-tool-height +
			$brand-builder-mobile-footer + 1}
	);
	display: flex;
	flex-direction: column;
	justify-content: center;

	@include tablet {
		height: calc(100vh - #{$top-nav-height + $brand-builder-tool-height + 60});
	}

	@media only screen and (max-width: 1023px) {
		width: calc(100vw - 20px) !important;
		padding: 0 10px;
		text-align: center;
	}

	@media only screen and (min-width: 1024px) and (max-width: 1374px) {
		height: calc(100vh - #{$top-nav-height + 60});
	}

	@media only screen and (min-width: 1375px) {
		height: calc(100vh - #{$top-nav-height + 45});
	}

	.loading-message {
		@include rem(margin-bottom, 25px);
		@include rem(font-size, 16px);
		@include typo--roboto__regular;
		color: $subheader-color;
	}
}
</style>
